// extracted by mini-css-extract-plugin
export default {"message":"ConfirmPopup_message__FamYy","centered":"ConfirmPopup_centered__EluhI"};